import {Assessment} from "../../shared/models/assessment";

export class AssessmentGroup {
    private id: number;
    private name: string;
    private assessments:Assessment[];
    private created:Date;
    private updated:Date;

    constructor() {
        this.assessments = [];
        this.created = new Date();
        this.updated = new Date();
    }

    get Id() {
        return this.id;
    }
    set Id(v:number) {
        this.id = v;
    }

    get Name() {
        return this.name;
    }
    set Name(v:string) {
        this.name = v;
    }

    get Assessments() {
        return this.assessments;
    }
    set Assessments(v:Assessment[]) {
        this.assessments = v;
    }

    get Created() {
        return this.created;
    }
    set Created(v) {
        this.created = v;
    }
    get Updated() {
        return this.updated;
    }
    set Updated(v) {
        this.updated = v;
    }




}


// WEBPACK FOOTER //
// ./src/app/shared/models/assessment-group.ts